import { toHumanString } from 'human-readable-numbers'
import { get } from 'lodash'
import accounting from 'accounting'

export const MAX_PLANS_BY_SKU = ['FA-MAX', 'FA-MAX-PLUS']

export const NON_OFFERED_PLANS = ['FA-COMPED-STANDARD', 'FA-EMPLOYEE', 'WA-FA-ONLY-BACKER', 'WA-FA-BUNDLE-BACKER', 'WA-FA-TEAM-BACKER']

export const PLANS_BY_SKU = ['FA-LITE', 'FA-STANDARD', 'FA-MAX']

export const PLUS_PLANS_BY_SKU = ['FA-LITE-PLUS', 'FA-STANDARD-PLUS', 'FA-MAX-PLUS']

export const ALL_PLANS_BY_SKU = ['FA-LITE', 'FA-LITE-PLUS', 'FA-STANDARD', 'FA-STANDARD-PLUS', 'FA-MAX', 'FA-MAX-PLUS']

export const PLAN_COLOR_BY_SKU = {
  'FA-LITE-PLUS': 'teal',
  'FA-STANDARD-PLUS': 'teal',
  'FA-MAX-PLUS': 'teal',
  'FA-LITE': 'yellow',
  'FA-STANDARD': 'yellow',
  'FA-MAX': 'yellow'
}

export const PLAN_ICONSTYLE_BY_SKU = {
  'FA-LITE': 'custom',
  'FA-LITE-PLUS': 'custom',
  'FA-STANDARD': 'custom',
  'FA-STANDARD-PLUS': 'custom',
  'FA-MAX': 'custom',
  'FA-MAX-PLUS': 'custom'
}

export const ALL_PLAN_SLUGS = ['pro-lite', 'pro-lite-plus', 'pro', 'pro-plus', 'pro-max', 'pro-max-plus']

export const ALL_PLANS_BY_PROPER_NAME = ['Pro Lite', 'Pro Lite+', 'Pro', 'Pro+', 'Pro Max', 'Pro Max+']

export function getAutoAppliedDiscounts() {
  return AUTO_APPLIED_DISCOUNT_CODES
}

export function getKickstarterDiscounts() {
  return AUTO_APPLIED_KICKSTARTER_DISCOUNT_CODES
}

export function getPromoCodes() {
  return PROMO_CODES
}

// Put any active promo codes here. Any promo code on the query string will take precidence.
// If we have a promo code we want applied across all plans, you'll want to make sure it's the
// only one in this list.
export const AUTO_APPLIED_DISCOUNT_CODES = []

// Used for Kickstarter backers. These discounts are applied automatically.
export const AUTO_APPLIED_KICKSTARTER_DISCOUNT_CODES = []

// This is used when we want to show a promo code to certain accounts
export const PROMO_CODES = {
  0: { id: null, code: null }
}

// This is used when we want to show a promo code to certain accounts
export function shouldHavePromoCode(account, subscription) {
  // return account && get(subscription, 'status', '') === 'active' && get(subscription, 'type', '') !== 'free'
  return false
}

// This is used when we want to show a promo code to certain accounts
export function getDiscountPercent(account, subscription) {
  return '0'
}

export const HANDLE_FUNCTIONS = {
  asText(params = {}) {
    const { field } = params

    return (plan) => {
      return { included: true, decorator: plan[field] }
    }
  },

  asBoolean(params = {}) {
    const { field } = params

    return (plan) => {
      return { included: plan[field] }
    }
  },

  asUnlimitedNumber(params = {}) {
    const { field } = params

    return (plan) => {
      const number = plan[field]

      return { included: number !== 0, decorator: this.unlimitedNumberFormatted(number) }
    }
  },

  asDeepFieldMatch(params = {}) {
    const { field, match } = params

    return (plan) => {
      const value = get(plan, field.split(' '), false)

      return { included: match.includes(value) }
    }
  },

  asHumanReadableNumber(params = {}) {
    const { field } = params

    return (plan) => {
      const number = plan[field]

      return { included: number !== 0, decorator: toHumanString(number) }
    }
  },

  asDataPerMonth(params = {}) {
    const { field, numberSuffix = 'GB' } = params

    return (plan) => {
      const total = plan[field]

      return { included: total !== 0, decorator: `${total} ${numberSuffix}` }
    }
  },

  asPriceWithSuffix(params = {}) {
    const { field, suffix, numberPrecision } = params

    return (plan) => {
      const number = get(plan, field, { amount: 0 })

      if (number !== null) {
        return { included: true, decorator: `${this.formatMoney(number.amount, numberPrecision)}${suffix}` }
      } else {
        return { included: false }
      }
    }
  },

  unlimitedNumberFormatted(number) {
    if (number < 0) {
      return 'Unlimited'
    } else {
      return number
    }
  },

  formatMoney(money, precision = 2) {
    const formattedMoney = (money || 0) / 100

    return accounting.formatMoney(formattedMoney, { precision: precision })
  }
}

export const TABLE_ROWS = [
  [
    {
      featureName: 'Plan',
      featureDescription: 'Plan',
      featureIcon: 'faFontAwesome',
      handleFunction: HANDLE_FUNCTIONS.asText({ field: 'name' })
    },
    {
      featureName: 'Price',
      featureDescription: 'Price',
      featureIcon: 'faBadgeDollar',
      handleFunction: HANDLE_FUNCTIONS.asPriceWithSuffix({ field: 'price', suffix: '/yr' })
    }
  ],
  [
    {
      featureName: 'Pro Icons',
      featureDescription: 'Access to all the Font Awesome Pro icons',
      featureIcon: 'faIcons',
      handleFunction: HANDLE_FUNCTIONS.asDeepFieldMatch({ field: 'iconCollection name', match: ['pro-collection', 'pro-plus-collection'] })
    },
    {
      featureName: 'Pro+ Icons',
      featureDescription: 'Access to all the Font Awesome Pro+ Icons icons',
      featureIcon: 'faShapes',
      handleFunction: HANDLE_FUNCTIONS.asDeepFieldMatch({ field: 'iconCollection name', match: ['pro-plus-collection'] })
    },
    {
      featureName: 'Icon Download',
      featureDescription: 'Download icons as SVGs or web fonts',
      featureIcon: 'faArrowDownToLine',
      handleFunction: HANDLE_FUNCTIONS.asBoolean({ field: 'proDownloadEnabled' })
    },
    {
      featureName: 'Custom Icons',
      featureDescription: 'Easily use your own icons right alongside official Font Awesome ones',
      featureIcon: 'faGrid2Plus',
      handleFunction: HANDLE_FUNCTIONS.asUnlimitedNumber({ field: 'customIcons' })
    }
  ],
  [
    {
      featureName: 'Seats/Users',
      featureDescription: 'Work as a team - cover additional users under your license',
      featureIcon: 'faUserGroup',
      handleFunction: HANDLE_FUNCTIONS.asUnlimitedNumber({ field: 'seats' })
    },
    {
      featureName: 'Project Kits',
      featureDescription: 'The easiest way to use Font Awesome without pushing code',
      featureIcon: 'faSuitcase',
      handleFunction: HANDLE_FUNCTIONS.asUnlimitedNumber({ field: 'kits' })
    },
    {
      featureName: 'Pageviews',
      featureDescription: 'Included pageviews per month on sites using Font Awesome Kits',
      featureIcon: 'faSignalBars',
      handleFunction: HANDLE_FUNCTIONS.asHumanReadableNumber({ field: 'monthlyPageviews' })
    },
    {
      featureName: 'Bandwidth',
      featureDescription: 'Bandwidth included per month for your projects using npm, Ruby, or Python private registries',
      featureIcon: 'faBox',
      handleFunction: HANDLE_FUNCTIONS.asDataPerMonth({ field: 'monthlyBandwidth', numberSuffix: 'GB' })
    }
  ],
  [
    {
      featureName: 'Figma',
      featureDescription: 'Use the Figma plugin to easily add SVG icons in your designs',
      featureIcon: 'faPenNib',
      handleFunction: HANDLE_FUNCTIONS.asBoolean({ field: 'proDownloadEnabled' })
    },
    {
      featureName: 'Hosted npm',
      featureDescription: 'Use our hosted Pro npm packages in your projects',
      featureIcon: 'faCloudCheck',
      handleFunction: HANDLE_FUNCTIONS.asBoolean({ field: 'proDownloadEnabled' })
    },
    {
      featureName: 'Perpetual License',
      featureDescription: 'Use the latest icons released during your plan forever',
      featureIcon: 'faFile',
      handleFunction: HANDLE_FUNCTIONS.asBoolean({ field: 'perpetualLicenseEnabled' })
    }
  ],
  [
    {
      featureName: 'Extra Seats',
      featureDescription: 'Price per extra seat',
      featureIcon: 'faCircleUser',
      handleFunction: HANDLE_FUNCTIONS.asPriceWithSuffix({ field: 'seatUpgradePrice', suffix: '/seat', numberPrecision: 0 })
    },
    {
      featureName: 'Extra Pageviews',
      featureDescription: 'Price per extra pageviews',
      featureIcon: 'faSignalBars',
      handleFunction: HANDLE_FUNCTIONS.asPriceWithSuffix({ field: 'overagePageviewPrice', suffix: ' per 250,000', numberPrecision: 0 })
    },
    {
      featureName: 'Extra Bandwidth',
      featureDescription: 'Price per extra bandwidth',
      featureIcon: 'faBoxes',
      handleFunction: HANDLE_FUNCTIONS.asPriceWithSuffix({ field: 'overageBandwidthPrice', suffix: ' per GB', numberPrecision: 2 })
    }
  ]
]
